import React from 'react'
import { TypeStateCalendarSchedule } from './Types'


const initialState: TypeStateCalendarSchedule = {
  view: 'month'
}

const useCalendarSchedule = () => {

  const [view, setView] = React.useState<TypeStateCalendarSchedule['view']>(initialState.view)

  const eventPropGetter = React.useCallback(
    (event: any, start: Date, end: Date, isSelected: boolean) => {

      return {
        ...(isSelected && {
          style: {
            // backgroundColor: otherColor.darkGrey,
          },
        }),
        ...({
          className: event.color,
        }),
      }
    },
    []
  )

  const resetState = () => {
    setView(initialState.view)
  }

  React.useEffect(()=>{
  },[])

  return {
    view,
    setView,
    eventPropGetter,
  }
}

export default useCalendarSchedule